import { QueryEngineBase } from '@comunica/actor-init-query';
/**
 * A Comunica SPARQL query engine.
 */
export class QueryEngine extends QueryEngineBase {
    constructor(engine) {
        super(engine);
    }
}
//# sourceMappingURL=QueryEngine.js.map